// extracted by mini-css-extract-plugin
module.exports = {"tooltip":"TipsInvoicing_tooltip_GfV1H"};